// import React, { useState, useEffect } from "react";
// import { Table, Select, Input, message, Modal } from "antd";
// import axios from "axios";
// // import { Rate } from "antd";
// import moment from "moment";
// import { FaBook, FaIdBadge, FaUserShield, FaBan,FaBell } from "react-icons/fa";
// import { EnvironmentOutlined } from "@ant-design/icons";
// import { Spin } from "antd";

// import { Tooltip } from "antd";

// const { Option } = Select;
// const { Search } = Input;

// const Orders = () => {
//   const [servicesData, setServicesData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchText, setSearchText] = useState("");
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [selectedFeedback, setSelectedFeedback] = useState("");
//   const [isOrderIdModalVisible, setIsOrderIdModalVisible] = useState(false);
//   const [selectedOrderId, setSelectedOrderId] = useState("");
//   const [isProviderIdModalVisible, setIsProviderIdModalVisible] = useState(false);
//   const [providerDetails, setProviderDetails] = useState(null);
//   const [isCancelModalVisible, setIsCancelModalVisible] = useState(false);
// const [cancelFeedback, setCancelFeedback] = useState(null);
// const [reminderLoading, setReminderLoading] = useState(false);

//   const authData = localStorage.getItem("auth");
//   const authObject = JSON.parse(authData);
//   const token = authObject?.accessToken;

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.get(
//           "http://localhost:4000/user/getAllOrders",
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );

//         // const apiData = response.data.data.bookedOrders.map((item) => ({
//         //   key: item._id,
//         //   name: `${item.firstName} ${item.lastName}`,
//         //   email: item.email,
//         //   phone: item.phoneNumber,
//         //   service: item.serviceName,
//         //   address: item.address,
//         //   mapAddress: item.mapAddress,
//         //   status: item.status,
//         //   feedback: item.feedback,
//         //   createdAt: item.createdAt,
//         //   providerId: item.providerId, // <-- add providerId
//         // }));

//         // setServicesData(apiData);
//         // setFilteredData(apiData);
//   // it show the new order in first
//   const apiData = response.data.data.bookedOrders
//   .map((item) => ({
//     key: item._id,
//     name: `${item.firstName} ${item.lastName}`,
//     email: item.email,
//     phone: item.phoneNumber,
//     service: item.serviceName,
//     address: item.address,
//     mapAddress: item.mapAddress,
//     status: item.status,
//     feedback: item.feedback,
//     createdAt: item.createdAt,
//     providerId: item.providerId,
//   }))
//   // ✅ Sort newest orders first
//   .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
// setServicesData(apiData);
// setFilteredData(apiData);

//       } catch (error) {
//         console.error("Error fetching data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [token]);

//   const onSearch = (value) => {
//     setSearchText(value);
//     const filtered = servicesData.filter((item) =>
//       Object.values(item).some((val) =>
//         String(val).toLowerCase().includes(value.toLowerCase())
//       )
//     );
//     setFilteredData(filtered);
//   };
//   const handleProviderClick = async (providerId) => {
//     try {
//       const res = await axios.get(`http://localhost:4000/user/providers/${providerId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setProviderDetails(res.data.provider);
//       setIsProviderIdModalVisible(true);
//     } catch (error) {
//       console.error("Failed to fetch provider info:", error);
//       message.error("Unable to load provider details");
//     }
//   };

//   const handleStatusChange = async (value, key) => {
//     const updatedData = servicesData.map((service) =>
//       service.key === key ? { ...service, status: value } : service
//     );
//     setServicesData(updatedData);
//     setFilteredData(updatedData);

//     try {
//       // Update order status
//       await axios.put(
//         `http://localhost:4000/user/updateOrderStatus/${key}`,
//         { status: value },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       message.success("Status updated successfully");
//     } catch (error) {
//       message.error("Failed to update status or send feedback email.");
//       console.error("Error:", error);
//     }
//   };

//   const handleFeedbackClick = async (orderId) => {
//     try {
//       setLoading(true); // Show loading state while fetching feedback

//       // Fetch feedback for the specific order using GET request
//       const response = await axios.get(
//         `http://localhost:4000/feedback/${orderId}`, // Use orderId in the API request
//         {
//           headers: {
//             Authorization: `Bearer ${token}`, // Pass token for authentication
//           },
//         }
//       );

//       const feedbackData = response.data.feedback;

//       if (!feedbackData) {
//         message.info("No feedback provided for this order.");
//         return;
//       }

//       setSelectedFeedback(feedbackData); // Set the feedback data
//       setIsModalVisible(true); // Show modal with feedback
//     } catch (error) {
//       console.error("Error fetching feedback:", error);
//       message.error("Failed to fetch feedback. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };
// const handleSendFeedbackReminder = async (orderId) => {
//   setReminderLoading(true); // Show loading
//   try {
//     await axios.post(
//       `http://localhost:4000/feedback/sendReminderEmail/${orderId}`,
//       {},
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );
//     message.success("Feedback reminder email sent successfully.");
//   } catch (error) {
//     console.error("Reminder send failed:", error);
//     message.error("Failed to send feedback reminder.");
//   } finally {
//     setReminderLoading(false); // Hide loading
//   }
// };

// const handleCancelFeedbackClick = async (orderId) => {
//   try {
//     setLoading(true);
//     // Fetch cancellation feedback for the specific order
//     const response = await axios.get(
//       `http://localhost:4000/feedback/cancel/${orderId}`,
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );
//     const feedbackData = response.data.feedback;
//     if (!feedbackData) {
//       message.info("No cancellation feedback provided for this order.");
//       return;
//     }
//     setCancelFeedback(feedbackData);
//     setIsCancelModalVisible(true);
//   } catch (error) {
//     console.error("Error fetching cancellation feedback:", error);
//     message.error("Failed to fetch cancellation feedback. Please try again later.");
//   } finally {
//     setLoading(false);
//   }
// };
//   const columns = [
//     {
//       title: "Order ID",
//       dataIndex: "key",
//       key: "orderId",
//       render: (orderId) => (
//         <FaIdBadge
//           style={{ cursor: "pointer", color: "#52c41a", fontSize: "18px" }}
//           title="Show Order ID"
//           onClick={() => {
//             setSelectedOrderId(orderId);
//             setIsOrderIdModalVisible(true);
//           }}
//         />
//       ),
//     },
//     {
//       title: "Name",
//       dataIndex: "name",
//       key: "name",
//     },
//     {
//       title: "Email",
//       dataIndex: "email",
//       key: "email",
//     },
//     {
//       title: "Phone",
//       dataIndex: "phone",
//       key: "phone",
//     },
//     {
//       title: "Service",
//       dataIndex: "service",
//       key: "service",
//     },
//     {
//       title: "Address",
//       dataIndex: "address",
//       key: "address",
//     },
//     {
//       title: "Date & Time",
//       dataIndex: "createdAt",
//       key: "createdAt",
//       render: (text) => (
//         <span>
//           {moment(text).format("MMMM Do YYYY, h:mm A")} <br />
//           ({moment(text).format("dddd")})
//         </span>
//       ),
//     },
//     {
//       title: "Status",
//       dataIndex: "status",
//       key: "status",
//       render: (status, record) => (
//         <Select
//           value={status}
//           onChange={(value) => handleStatusChange(value, record.key)}
//           style={{ borderRadius: "12px", padding: "4px 8px" }}
//         >
//           <Option value="Pending">Pending</Option>
//           <Option value="Completed">Completed</Option>
//           <Option value="Inprocess">Inprocess</Option>
//           <Option value="Declined">Declined</Option>
//         </Select>
//       ),
//     },
//    {
//   title: "Feedback",
//   dataIndex: "feedback",
//   key: "feedback",
//   render: (_, record) => {
//     if (record.status === "Completed") {
//       return (
//         <FaBook
//           onClick={() => handleFeedbackClick(record.key)}
//           style={{
//             cursor: "pointer",
//             color: "#1890ff",
//             fontSize: "18px",
//           }}
//           title="View Feedback"
//         />
//       );
//     } else if (
//       record.status === "Declined" ||
//       record.status === "Cancelled" ||
//       record.status === "Canceled"
//     ) {
//       return (
//         <FaBan
//           onClick={() => handleCancelFeedbackClick(record.key)}
//           style={{
//             cursor: "pointer",
//             color: "#d9534f",
//             fontSize: "18px",
//           }}
//           title="View Cancellation Feedback"
//         />
//       );
//     }
//     return null;
//   },
// },
// {
//   title: "Feedback Reminder",
//   key: "feedbackReminder",
//   render: (_, record) => {
//     if (record.status === "Completed" && !record.feedback) {
//       return reminderLoading ? (
//         <Spin size="small" />
//       ) : (
//         <FaBell
//           onClick={() => handleSendFeedbackReminder(record.key)}
//           style={{
//             cursor: "pointer",
//             color: "#fadb14",
//             fontSize: "18px",
//           }}
//           title="Send Feedback Reminder"
//         />
//       );
//     }
//     return null;
//   },
// },
//     {
//       title: "Provider Info",
//       dataIndex: "providerId",
//       key: "providerId",
//       render: (providerId) => (
//         <FaUserShield
//           style={{ cursor: "pointer", color: "#faad14", fontSize: "18px" }}
//           title="Show Provider Info"
//           onClick={() => handleProviderClick(providerId)}
//         />
//       ),
//     },


//     {
//       title: "Map Address",
//       dataIndex: "mapAddress",
//       key: "mapAddress",
//       render: (text) => (
//         <Tooltip title="Open Location">
//           <a
//             href={text}
//             target="_blank"
//             rel="noopener noreferrer"
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               color: "#1890ff",
//             }}
//           >
//             <EnvironmentOutlined style={{ fontSize: "18px", marginRight: "8px" }} />
//             View Location
//           </a>
//         </Tooltip>
//       ),
//     },
//   ];

//   return (
//     <div className="bg-gray-100 min-h-screen p-6">
//       <div className="bg-white p-6 rounded-lg shadow-lg">
//         <h3 className="mb-4 text-xl font-semibold">Orders</h3>

//         {/* Search input */}
//         <Search
//           placeholder="Search orders"
//           enterButton
//           value={searchText}
//           onChange={(e) => onSearch(e.target.value)}
//           className="mb-4"
//         />

//         {/* Orders Table */}
//         <Table
//           columns={columns}
//           dataSource={filteredData}
//           loading={loading}
//           scroll={{ x: 'max-content' }} // 👈 enables horizontal scroll if needed
//           pagination={{
//             pageSize: 10,
//             total: filteredData.length,
//             showSizeChanger: false,
//             defaultCurrent: 1,
//           }}
//            rowClassName={(record) => {
//     if (record.status === "Pending") return "bg-red-50"; // light red
//     if (record.status === "Completed") return "bg-green-50"; // light green
//     return "";
//   }}
//         />

//         {/* Order ID Modal */}
//         <Modal
//           title="Order Unique ID"
//           visible={isOrderIdModalVisible}
//           onCancel={() => setIsOrderIdModalVisible(false)}
//           footer={null}
//           centered
//         >
//           <div style={{ textAlign: "center", fontSize: "18px", wordBreak: "break-all" }}>
//             <strong>{selectedOrderId}</strong>
//           </div>
//           <div style={{ marginTop: "20px", textAlign: "center" }}>
//             <button
//               onClick={() => setIsOrderIdModalVisible(false)}
//               style={{
//                 backgroundColor: "#1890ff",
//                 color: "#fff",
//                 padding: "8px 18px",
//                 borderRadius: "6px",
//                 border: "none",
//                 cursor: "pointer",
//               }}
//             >
//               Close
//             </button>
//           </div>
//         </Modal>

//         {/* Provider ID Modal */}
// <Modal 
//   title=" Provider Information"
//   visible={isProviderIdModalVisible}
//   onCancel={() => {
//     setIsProviderIdModalVisible(false);
//     setProviderDetails(null);
//   }}
//   footer={null}
//   centered
// >
//   {providerDetails ? (
//     <div style={{ fontSize: "16px", lineHeight: "1.8" }}>
//       <p><strong>Name:</strong> {providerDetails.firstName} {providerDetails.lastName}</p>
//       <p><strong>Category:</strong> {providerDetails.category}</p>
//       <p><strong>Phone:</strong> {providerDetails.phoneNumber}</p>
//       <p><strong>Email:</strong> {providerDetails.email}</p>
//       <p><strong>Address:</strong> {providerDetails.address}</p>
//       <div style={{ marginTop: "20px", textAlign: "center", display: "flex", flexDirection: "column", gap: "10px" }}>
//         {/* WhatsApp Button */}
//         <a
//           href={`https://wa.me/${providerDetails.phoneNumber.replace(/[^0-9]/g, "")}?text=${encodeURIComponent(
//             `Hello ${providerDetails.firstName}, I am contacting you regarding my order from HomeBasedService.`
//           )}`}
//           target="_blank"
//           rel="noopener noreferrer"
//           style={{
//             backgroundColor: "#25D366",
//             color: "#fff",
//             padding: "8px 18px",
//             borderRadius: "6px",
//             border: "none",
//             cursor: "pointer",
//             textDecoration: "none",
//             display: "inline-block",
//             fontWeight: "bold"
//           }}
//         >
//           Contact via WhatsApp
//         </a>
//         {/* Email Button */}
//         <a
//           href={`mailto:${providerDetails.email}?subject=${encodeURIComponent(
//             "Order Inquiry from HomeBasedService"
//           )}&body=${encodeURIComponent(
//             `Hello ${providerDetails.firstName},I am contacting you regarding my order from HomeBasedService.Thank you.`
//           )}`}
//           style={{
//             backgroundColor: "#1890ff",
//             color: "#fff",
//             padding: "8px 18px",
//             borderRadius: "6px",
//             border: "none",
//             cursor: "pointer",
//             textDecoration: "none",
//             display: "inline-block",
//             fontWeight: "bold"
//           }}
//         >
//           Contact via Email
//         </a>
//         {/* Close Button */}
//         <button
//           onClick={() => {
//             setIsProviderIdModalVisible(false);
//             setProviderDetails(null);
//           }}
//           style={{
//             backgroundColor: "#faad14",
//             color: "#fff",
//             padding: "8px 18px",
//             borderRadius: "6px",
//             border: "none",
//             cursor: "pointer",
//             marginTop: "10px"
//           }}
//         >
//           Close
//         </button>
//       </div>
//     </div>
//   ) : (
//     <p>Loading...</p>
//   )}
// </Modal>


// {/* Feedback Modal for Completed Orders */}
// <Modal
//   title="Service Feedback"
//   visible={isModalVisible}
//   onCancel={() => {
//     setIsModalVisible(false);
//     setSelectedFeedback("");
//   }}
//   footer={null}
//   centered
// >
//   {selectedFeedback ? (
//     <div style={{ lineHeight: "1.8", padding: "10px" }}>
//       <p>
//         <strong>Total Charges:</strong> Rs. {selectedFeedback.totalCharges}
//       </p>
//       <p>
//         <strong>Rating:</strong>{" "}
//         <span style={{ fontSize: "18px", color: "#faad14" }}>
//           {"⭐".repeat(selectedFeedback.rating)}
//         </span>
//       </p>
//       <p>
//         <strong>Feedback:</strong> {selectedFeedback.feedback}
//       </p>
//     </div>
//   ) : (
//     <p>No feedback available.</p>
//   )}
// </Modal>

// {/* Cancel Feedback Modal */}
// <Modal
//   title="Cancellation Feedback"
//   visible={isCancelModalVisible}
//   onCancel={() => setIsCancelModalVisible(false)}
//   footer={null}
//   centered
// >
//   {cancelFeedback ? (
//     <div style={{ padding: "20px", lineHeight: "1.8" }}>
//       <p>
//         <strong>Reason:</strong>{" "}
//         <span style={{ color: "#d9534f" }}>
//           {cancelFeedback.reason || "No reason provided"}
//         </span>
//       </p>
//       {/* <p>
//         <strong>Comments:</strong> {cancelFeedback.comments || "No comments provided"}
//       </p> */}
//     </div>
//   ) : (
//     <p>Loading...</p>
//   )}
// </Modal>

//       </div>
//     </div>
//   );
// };

// export default Orders;


import React, { useState, useEffect } from "react";
import { Table, Input, message, Modal, Select, Tooltip, Spin } from "antd";
import axios from "axios";
import moment from "moment";
import {
  FaBook,
  FaIdBadge,
  FaUserShield,
  FaBan,
  FaBell,
} from "react-icons/fa";
import { EnvironmentOutlined } from "@ant-design/icons";

const { Option } = Select;
const { Search } = Input;

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [selectedFeedback, setSelectedFeedback] = useState("");
  const [selectedOrderId, setSelectedOrderId] = useState("");
  const [providerDetails, setProviderDetails] = useState(null);
  const [cancelFeedback, setCancelFeedback] = useState(null);
  const [reminderLoading, setReminderLoading] = useState(false);

  const [modal, setModal] = useState({
    feedback: false,
    orderId: false,
    provider: false,
    cancel: false,
  });

  const authData = localStorage.getItem("auth");
  const authObject = JSON.parse(authData);
  const token = authObject?.accessToken;

  // ✅ Normalize all status strings (handle Cancelled/Canceled/Processing etc.)
  const normalizeStatus = (status) => {
    if (!status) return "Pending";
    const s = status.trim().toLowerCase();
    if (["cancelled", "canceled", "declined"].includes(s)) return "Declined";
    if (["processing", "inprocess", "in progress"].includes(s))
      return "Inprocess";
    if (["completed", "done", "finished"].includes(s)) return "Completed";
    return "Pending";
  };

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const res = await axios.get(`${API_BASE}/user/getAllOrders`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const apiData = res.data.data.bookedOrders
          .map((item) => ({
            key: item._id,
            name: `${item.firstName} ${item.lastName}`,
            email: item.email,
            phone: item.phoneNumber,
            service: item.serviceName,
            address: item.address,
            mapAddress: item.mapAddress,
            status: normalizeStatus(item.status),
            feedback: item.feedback,
            createdAt: item.createdAt,
            providerId: item.providerId,
          }))
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

        setOrders(apiData);
        setFilteredOrders(apiData);
        console.log("✅ Total Orders Fetched:", apiData.length);
      } catch (error) {
        console.error("Error fetching orders:", error);
        message.error("Failed to load orders");
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, [token]);

  // 🔍 Search functionality
  const onSearch = (value) => {
    setSearchText(value);
    const filtered = orders.filter((item) =>
      Object.values(item).some((val) =>
        String(val).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredOrders(filtered);
  };

  // ⚙️ Status update
  const handleStatusChange = async (value, key) => {
    const updated = orders.map((order) =>
      order.key === key ? { ...order, status: value } : order
    );
    setOrders(updated);
    setFilteredOrders(updated);

    try {
      await axios.put(
        `${API_BASE}/user/updateOrderStatus/${key}`,
        { status: value },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      message.success("Order status updated successfully");
    } catch (error) {
      console.error("Error updating status:", error);
      message.error("Failed to update order status");
    }
  };

  // 📩 Feedback actions
  const handleFeedbackClick = async (orderId) => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_BASE}/feedback/${orderId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.data.feedback) return message.info("No feedback available");
      setSelectedFeedback(res.data.feedback);
      setModal((m) => ({ ...m, feedback: true }));
    } catch (err) {
      message.error("Failed to fetch feedback");
    } finally {
      setLoading(false);
    }
  };

  const handleCancelFeedbackClick = async (orderId) => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${API_BASE}/feedback/cancel/${orderId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (!res.data.feedback)
        return message.info("No cancellation feedback available");
      setCancelFeedback(res.data.feedback);
      setModal((m) => ({ ...m, cancel: true }));
    } catch (err) {
      message.error("Failed to fetch cancellation feedback");
    } finally {
      setLoading(false);
    }
  };

  const handleSendFeedbackReminder = async (orderId) => {
    setReminderLoading(true);
    try {
      await axios.post(
        `${API_BASE}/feedback/sendReminderEmail/${orderId}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      message.success("Feedback reminder sent");
    } catch (err) {
      message.error("Failed to send feedback reminder");
    } finally {
      setReminderLoading(false);
    }
  };

  // 👨‍🔧 Provider Info
  const handleProviderClick = async (providerId) => {
    try {
      const res = await axios.get(
        `${API_BASE}/user/providers/${providerId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setProviderDetails(res.data.provider);
      setModal((m) => ({ ...m, provider: true }));
    } catch (error) {
      message.error("Failed to load provider info");
    }
  };

  // 🧱 Table Columns
  const columns = [
    {
      title: "Order ID",
      dataIndex: "key",
      key: "orderId",
      render: (id) => (
        <FaIdBadge
          style={{ cursor: "pointer", color: "#52c41a" }}
          onClick={() => {
            setSelectedOrderId(id);
            setModal((m) => ({ ...m, orderId: true }));
          }}
        />
      ),
    },
    { title: "Name", dataIndex: "name" },
    { title: "Email", dataIndex: "email" },
    { title: "Phone", dataIndex: "phone" },
    { title: "Service", dataIndex: "service" },
    { title: "Address", dataIndex: "address" },
    {
      title: "Date",
      dataIndex: "createdAt",
      render: (t) => moment(t).format("MMMM Do YYYY, h:mm A"),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status, record) => (
        <Select
          value={status}
          onChange={(val) => handleStatusChange(val, record.key)}
        >
          <Option value="Pending">Pending</Option>
          <Option value="Inprocess">Inprocess</Option>
          <Option value="Completed">Completed</Option>
          <Option value="Declined">Declined</Option>
        </Select>
      ),
    },
    {
      title: "Feedback",
      render: (_, record) => {
        if (record.status === "Completed") {
          return (
            <FaBook
              onClick={() => handleFeedbackClick(record.key)}
              style={{ color: "#1890ff", cursor: "pointer" }}
            />
          );
        } else if (record.status === "Declined") {
          return (
            <FaBan
              onClick={() => handleCancelFeedbackClick(record.key)}
              style={{ color: "#d9534f", cursor: "pointer" }}
            />
          );
        }
        return null;
      },
    },
    {
      title: "Reminder",
      render: (_, record) =>
        record.status === "Completed" && !record.feedback ? (
          reminderLoading ? (
            <Spin size="small" />
          ) : (
            <FaBell
              onClick={() => handleSendFeedbackReminder(record.key)}
              style={{ color: "#fadb14", cursor: "pointer" }}
            />
          )
        ) : null,
    },
    {
      title: "Provider",
      render: (pid) => (
        <FaUserShield
          style={{ cursor: "pointer", color: "#faad14" }}
          onClick={() => handleProviderClick(pid)}
        />
      ),
    },
    {
      title: "Map",
      dataIndex: "mapAddress",
      render: (url) => (
        <Tooltip title="View on map">
          <a href={url} target="_blank" rel="noopener noreferrer">
            <EnvironmentOutlined />
          </a>
        </Tooltip>
      ),
    },
  ];

  // 🧮 Split into 4 groups
  const grouped = {
    Pending: filteredOrders.filter((o) => o.status === "Pending"),
    Inprocess: filteredOrders.filter((o) => o.status === "Inprocess"),
    Completed: filteredOrders.filter((o) => o.status === "Completed"),
    Declined: filteredOrders.filter((o) => o.status === "Declined"),
  };

  const renderTable = (title, data, color) => (
    <div className="bg-white p-6 rounded-lg shadow-lg mb-8">
      <h3 className="text-lg font-semibold mb-3" style={{ color }}>
        {title} Orders ({data.length})
      </h3>
      <Table
        rowKey="key"
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={{ pageSize: 10 }}
        rowClassName={() =>
          title === "Completed"
            ? "bg-green-50"
            : title === "Pending"
            ? "bg-red-50"
            : ""
        }
      />
    </div>
  );
const API_BASE = process.env.REACT_APP_API_BASE;

  return (
    <div className="bg-gray-100 min-h-screen p-6">
      <div className="bg-white p-4 rounded-lg shadow-md mb-6">
        <Search
          placeholder="Search orders"
          enterButton
          allowClear
          value={searchText}
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>

      {renderTable("Pending", grouped.Pending, "#d32f2f")}
      {renderTable("Inprocess", grouped.Inprocess, "#faad14")}
      {renderTable("Completed", grouped.Completed, "#52c41a")}
      {renderTable("Declined", grouped.Declined, "#9e9e9e")}

      {/* Modals */}
      <Modal
        title="Order ID"
        open={modal.orderId}
        onCancel={() => setModal((m) => ({ ...m, orderId: false }))}
        footer={null}
        centered
      >
        <p>{selectedOrderId}</p>
      </Modal>

      <Modal
        title="Provider Info"
        open={modal.provider}
        onCancel={() => setModal((m) => ({ ...m, provider: false }))}
        footer={null}
        centered
      >
        {providerDetails ? (
          <>
            <p>
              <strong>Name:</strong> {providerDetails.firstName}{" "}
              {providerDetails.lastName}
            </p>
            <p>
              <strong>Email:</strong> {providerDetails.email}
            </p>
            <p>
              <strong>Phone:</strong> {providerDetails.phoneNumber}
            </p>
          </>
        ) : (
          <p>Loading...</p>
        )}
      </Modal>

      <Modal
        title="Feedback"
        open={modal.feedback}
        onCancel={() => setModal((m) => ({ ...m, feedback: false }))}
        footer={null}
      >
        {selectedFeedback ? (
          <>
            <p>
              <strong>Rating:</strong>{" "}
              {"⭐".repeat(selectedFeedback.rating || 0)}
            </p>
            <p>{selectedFeedback.feedback}</p>
          </>
        ) : (
          <p>No feedback available.</p>
        )}
      </Modal>

      <Modal
        title="Cancellation Feedback"
        open={modal.cancel}
        onCancel={() => setModal((m) => ({ ...m, cancel: false }))}
        footer={null}
      >
        {cancelFeedback ? (
          <p>
            <strong>Reason:</strong> {cancelFeedback.reason || "No reason"}
          </p>
        ) : (
          <p>No cancellation feedback available.</p>
        )}
      </Modal>
    </div>
  );
};

export default Orders;
